// extracted by mini-css-extract-plugin
export default {"language-select-container":"LanguageSelector_language-select-container__Vxdwf"};